import * as React from 'react';
import { translate } from 'react-i18next';
import * as c from 'models/constants';
import { IStore } from 'redux/IStore';
import { reduxForm, getFormSyncErrors, Field } from 'redux-form';
import { ErrorSummary } from 'components';
import { ErrorPage } from 'containers';
import { InjectedRouter } from 'react-router';
import { showModal, closeModal } from 'modules/modal';
import { IModalAction } from 'models/modal';
import { IManageOutfit, IManageOutfitAction } from 'models/outfit/manageoutfit';
import { IOutfit } from 'models/outfit/outfit';
import { OutfitEditorHeader } from '../OutfitEditorHeader';
import { minLength } from 'helpers/validationattributes';
import { ISelectorItem } from 'models/common';
import { ItemsSelector } from '../../../Common/ItemsSelector';
import { IOutfitItem } from 'models/outfit/outfititem';
import { SearchUsage } from 'models';
const { connect } = require('react-redux');

interface IProps {
	currentFormValues: IOutfit;
	initialValues: IManageOutfit;
	manageOutfit: IManageOutfit;
	location?: any;
	router: InjectedRouter;
	route: any;
	userId: string;
	wardrobeItemsSearchUsage: SearchUsage;

	/* form props */
	pristine: boolean;
	dirty: boolean;
	submitting: boolean;
	handleSubmit: any;
	submitFailed: boolean;
	formErrors?: any;

	/* functions props */
	t?: (key: string) => string;
	nextStep?: () => IManageOutfitAction;
	showModal: (modalType: string, modalProps: any) => IModalAction;
	closeModal: () => IModalAction;
	removeOutfitItem: (index: number) => IManageOutfitAction;
	addOutfitItem: (item: IOutfitItem) => IManageOutfitAction;
	setOutfitValidationFailure?: (error: any) => IManageOutfitAction;
}

const minValue1 = minLength(1);

@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class StepSelectItemsForm extends React.Component<IProps, any> {
	constructor(props) {
		super(props);

		this.onSubmit = this.onSubmit.bind(this);
		this.goBack = this.goBack.bind(this);
		this.cancelClick = this.cancelClick.bind(this);
		this.removeOutfitItem = this.removeOutfitItem.bind(this);
		this.selectItemObject = this.selectItemObject.bind(this);
	}

	public onSubmit() {
		this.props.nextStep();
	}

	private mapErrorKeyToMessage(key: string, t: (key: string) => string) {
		switch (key) {
			case 'items':
				return t('Outfit_CreateOutfit_SelectItems_Label_Items');
			default:
				return key;
		}
	}

	private goBack() {
		this.props.closeModal();
	}

	private cancelClick() {
		this.props.closeModal();
	}

	private removeOutfitItem(index: number) {
		this.props.removeOutfitItem(index);
	}

	private selectItemObject(item: ISelectorItem) {
		const itemToAdd: IOutfitItem = {
			name: item.name,
			entityId: item.entityId,
			order: 0,
			picture: item.picture,
			addedBy: item.addedBy,
			price: item.price,
			originalPrice: item.originalPrice,
			shopCurrencyKey: item.shopCurrencyKey,
		};
		this.props.addOutfitItem({
			...itemToAdd,
		});
	}

	private onKeyPress(event: any) {
		if (event.key === 'Enter') {
			event.preventDefault();
		}
	}

	public render() {
		// we also have error summary component, so if 422 let error pass to error summary
		if (this.props.manageOutfit.error && this.props.manageOutfit.message.status !== 422) {
			return <ErrorPage {...this.props} message={this.props.manageOutfit.message} />;
		}

		const { handleSubmit, formErrors, submitFailed, location, submitting, t, wardrobeItemsSearchUsage } = this.props;
		const { outfit, error, message } = this.props.manageOutfit;
		let { pristine } = this.props;

		const errorSummaryProps = {
			formErrors,
			submitFailed,
			error,
			message,
			location,
			mapErrorKeyToMessage: this.mapErrorKeyToMessage,
		};

		if (!outfit) {
			return null;
		}

		if (this.props.currentFormValues.itemsJArray && this.props.currentFormValues.itemsJArray.length > 0) {
			pristine = false;
		}

		const outfitEditorHeaderProps: any = {
			wizardStep: 1,
			title: t('Outfit_CreateOutfit_SelectItems_Title'),
			previousPage: this.goBack,
			cancelClick: this.cancelClick,
			pristine,
			submitting,
		};

		return (
			<div className="createOutfitSelectItems">
				<div className="profileError">
					<ErrorSummary {...errorSummaryProps} />
				</div>
				<form onSubmit={handleSubmit(this.onSubmit)} onKeyPress={this.onKeyPress}>
					<Field name="itemsJArray" validate={minValue1} type="hidden" component="input" />
					<OutfitEditorHeader {...outfitEditorHeaderProps} />
					<ItemsSelector
						onRemoveItem={this.removeOutfitItem}
						onSelectItemObject={this.selectItemObject}
						items={[...this.props.currentFormValues.itemsJArray]}
						selectedTab={c.ITEMS_SELECTOR_TAB_WARDROBE}
						productsSeachUsage={SearchUsage.ProductsSearch}
						wardrobeItemsSearchUsage={wardrobeItemsSearchUsage}
						userId={this.props.userId}
					/>
				</form>
			</div>
		);
	}
}

let StepSelectItems = reduxForm({
	form: c.FORM_NAME_MANAGEOUTFIT,
	destroyOnUnmount: false,
	forceUnregisterOnUnmount: true,
})(StepSelectItemsForm);

StepSelectItems = connect(
	(state: IStore) => {
		let currentFormValues: IOutfit = null;
		if (state.form[c.FORM_NAME_MANAGEOUTFIT] && state.form[c.FORM_NAME_MANAGEOUTFIT].values) {
			currentFormValues = state.form[c.FORM_NAME_MANAGEOUTFIT].values;
		} else {
			currentFormValues = state.manageOutfit.outfit;
		}

		return {
			initialValues: state.manageOutfit.outfit,
			manageOutfit: state.manageOutfit,
			currentFormValues,
			formErrors: getFormSyncErrors(c.FORM_NAME_MANAGEOUTFIT)(state),
			userCard: state.usercard.usercard,
		};
	},
	(dispatch) => ({
		closeModal: () => dispatch(closeModal()),
		showModal: (modalType: string, modalProps: any) => dispatch(showModal(modalType, modalProps)),
	}),
)(StepSelectItems);

export { StepSelectItems };
